<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="客户"
                        prop="customerid">
            <remote-select class="width-max"
                           clearable
                           placeholder="请输入客户名称/编号搜索"
                           v-model="search.customerid"
                           :query-request="getCustomerTable"
                           :find-request="getCustomerDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入项目 名称 进行搜索"
                           v-model="search.projectid"
                           :query-request="getProjectTable"
                           :find-request="getProjectDetail">
            </remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetSearch()"
                     size="mini">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <order-appeal-list-tabs active="internStat"></order-appeal-list-tabs>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                ref="multipleTable">
        <el-table-column prop="id"
                         width="100"
                         label="ID">
        </el-table-column>
        <el-table-column prop="realname"
                         min-width="120"
                         label="实习生姓名">
          <template slot-scope="scope">
            {{ scope.row.realname || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="name"
                         min-width="140"
                         label="账号">
          <template slot-scope="scope">
            {{ scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_work_days"
                         width="140"
                         label="系统累计出勤天数">
          <template slot-scope="scope">
            {{ scope.row.total_work_days != null ? scope.row.total_work_days : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="wrong_count"
                         width="120"
                         label="误审单量">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import OrderAppealListTabs from '@views/order/components/OrderAppealListTabs.vue'

export default {
  components: {OrderAppealListTabs},
  mixins: [table],
  data () {
    return {
      table: [],
      // 合并结果缓存，避免翻页时重复请求
      mergedRows: [],
      search: {
        customerid: null,
        projectid: null,
      },
      searchFieldType: {
        customerid: Number,
        projectid: Number,
      },
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
    }
  },
  methods: {
    ...request.map([
      'getCustomerTable', 'getCustomerDetail',
      'getProjectTable', 'getProjectDetail',
    ]),
    /**
     * 1) core 聚合误审单量 2) order-audit 补齐未转全职实习生信息与出勤天数 3) 前端分页
     */
    getTableData (params) {
      const searchParams = removeEmptyParams({
        customerid: params.customerid,
        projectid: params.projectid,
      })
      const page = Number(params.current_page) || 1
      const perPage = Number(params.per_page) || 20
      const cacheKey = JSON.stringify(searchParams)

      // 同筛选条件下翻页复用已合并数据
      if (this._statCacheKey === cacheKey && Array.isArray(this.mergedRows) && this.mergedRows.length) {
        return Promise.resolve(this.buildPageResponse(this.mergedRows, page, perPage))
      }

      return request.common('queryOrderAppealInternWrongStatApi', searchParams).then(statRes => {
        const statList = (statRes && Array.isArray(statRes.data)) ? statRes.data : []
        if (!statList.length) {
          this._statCacheKey = cacheKey
          this.mergedRows = []
          return this.buildPageResponse([], page, perPage)
        }

        const countMap = {}
        const ids = []
        statList.forEach(row => {
          const id = Number(row.order_reviewer_id)
          if (!id) return
          countMap[id] = Number(row.wrong_count) || 0
          ids.push(id)
        })
        if (!ids.length) {
          this._statCacheKey = cacheKey
          this.mergedRows = []
          return this.buildPageResponse([], page, perPage)
        }

        // 实习生列表接口会自动排除已转全职账号；per_page>500 会静默回落 20，故按 500 分批拉取
        return this.fetchInternsByIds(ids).then(interns => {
          const merged = interns
            .map(user => ({
              id: user.id,
              realname: user.realname,
              name: user.name,
              total_work_days: user.total_work_days,
              wrong_count: countMap[user.id] || 0,
            }))
            .filter(row => row.wrong_count > 0)
            .sort((a, b) => b.wrong_count - a.wrong_count)

          this._statCacheKey = cacheKey
          this.mergedRows = merged
          return this.buildPageResponse(merged, page, perPage)
        })
      })
    },
    fetchInternsByIds (ids) {
      const chunkSize = 500
      const chunks = []
      for (let i = 0; i < ids.length; i += chunkSize) {
        chunks.push(ids.slice(i, i + chunkSize))
      }
      return Promise.all(chunks.map(chunk => {
        return request.common('queryInternTableApi', {
          id: chunk,
          current_page: 1,
          per_page: Math.max(chunk.length, 20),
        }).then(internRes => {
          return (internRes && internRes.data && Array.isArray(internRes.data.data))
            ? internRes.data.data
            : []
        })
      })).then(lists => {
        const interns = []
        lists.forEach(list => {
          list.forEach(item => interns.push(item))
        })
        return interns
      })
    },
    buildPageResponse (rows, page, perPage) {
      const start = (page - 1) * perPage
      return {
        data: {
          data: rows.slice(start, start + perPage),
          total: rows.length,
          current_page: page,
          per_page: perPage,
        },
      }
    },
    onRefresh () {
      this._statCacheKey = null
      this.mergedRows = []
      return this.getTableData(this.lastSearchParams).then(this.setTableData)
    },
  },
}
</script>

<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/pages/OrderAppealInternStatTable.vue